import {
  cmsApiOnDepartureChangeSelector,
  cmsApiOnArrivalChangeSelector,
} from 'app/store/selectors';
import {
  setLocation as setLocationAction,
  clearAutocompleteResults,
} from 'app/store/reducers/location';
import { ThunkType } from 'app/hooks/appHooks';
import { SearchMaskDirection, SearchMaskLocation } from 'app/models/types/store/location';
import { loadPopularCities } from 'app/store/thunk/location/loadPopularCitiesThunk';

export type SetLocationType = {
  direction: SearchMaskDirection;
  location: SearchMaskLocation;
};

export const setLocation =
  ({ direction, location }: SetLocationType): ThunkType<void> =>
  (dispatch, getState) => {
    dispatch(setLocationAction({ direction, location }));

    const state = getState();
    // construct and send payload to cmsApi
    const payload = {
      cityName: location.name,
      legacyId: location.legacyId,
      uuid: location.uuid,
    };

    const onDepartureChanged: ReturnType<typeof cmsApiOnDepartureChangeSelector> =
      cmsApiOnDepartureChangeSelector(state);
    const onArrivalChanged: ReturnType<typeof cmsApiOnArrivalChangeSelector> =
      cmsApiOnArrivalChangeSelector(state);

    const method = direction === 'from' ? onDepartureChanged : onArrivalChanged;
    method(payload);

    // clear autocomplete results for this direction
    dispatch(clearAutocompleteResults({ direction }));
    if (direction === 'from') {
      dispatch(loadPopularCities({ direction: 'to' }));
    }
  };
